import { useEffect, useState } from 'react';
import classNames from 'classnames';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import SearchSparkle from '@alltrails/denali/icons/SearchSparkle';
import { getNlSuggestions } from '../../requests/nlSearchRequests';
import styles from './styles/NLSearchSuggestions.module.scss';

const SuggestionShimmer = () => {
  return (
    <ShimmerContainer className={styles.suggestionsContainer}>
      <div className={styles.suggestionsRow}>
        <div className={classNames(styles.searchSuggestion, styles.loading)} />
        <div className={classNames(styles.searchSuggestion, styles.loading)} />
        <div className={classNames(styles.searchSuggestion, styles.loading)} />
      </div>
      <div className={styles.suggestionsRow}>
        <div className={classNames(styles.searchSuggestion, styles.loading)} />
        <div className={classNames(styles.searchSuggestion, styles.loading)} />
        <div className={classNames(styles.searchSuggestion, styles.loading)} />
      </div>
    </ShimmerContainer>
  );
};

type Props = {
  onSelect: (text: string) => void;
};

const NLSearchSuggestions = ({ onSelect }: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [suggestions, setSuggestions] = useState<{ text: string }[]>([]);

  useEffect(() => {
    async function fetchSuggestions() {
      try {
        const response = await getNlSuggestions();
        setSuggestions(response.suggestions);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchSuggestions();
  }, []);

  if (isLoading) {
    return <SuggestionShimmer />;
  }

  const suggestionButtons = suggestions.map(suggestion => (
    <button key={suggestion.text} className={styles.searchSuggestion} onClick={() => onSelect(suggestion.text)}>
      <SearchSparkle color="currentColor" size="sm" />
      {suggestion.text}
    </button>
  ));
  const totalCount = suggestions.length;
  const firstRowCount = Math.ceil(totalCount / 2);

  return (
    <div className={styles.suggestionsContainer}>
      <div className={styles.suggestionsRow}>{suggestionButtons.slice(0, firstRowCount).map(button => button)}</div>
      <div className={styles.suggestionsRow}>{suggestionButtons.slice(firstRowCount).map(button => button)}</div>
    </div>
  );
};

export default NLSearchSuggestions;
